export const APP_STORE_URL = 'https://apps.apple.com/us/app/anchor-billing-collections/id6783825784';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.sayanchor.app';
export const getStoreUrl = (userAgent)=>{
    if (/iphone|ipad|ipod/i.test(userAgent)) {
        return APP_STORE_URL;
    }
    if (/android/i.test(userAgent)) {
        return GOOGLE_PLAY_URL;
    }
    return null;
};
